<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex>
        <v-dialog v-model="recuperaSenhaDialog" max-width="80%" persistent>
          <v-card>
            <v-card-title>
              <div class="headline" style="color: #4a4a4a">{{ $t("login.resetPassword") }}</div>
            </v-card-title>

            <v-card-text>
              <div>{{ $t("login.emailPrompt") }}</div>
              <v-form ref="formRecuperaSenha" v-model="formRecuperaSenhaValidado">
                <v-text-field v-model="email" :label="$t('passengers.personal.email')" hint="usuario@email.com" type="email"
                  prepend-icon="mdi-email" :rules="[validaEmail]" :loading="loadingRecuperaSenha">
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <div v-if="alertaEmail" style="color: red;">{{ mensagemAlertaEmail }}</div>
              <v-spacer></v-spacer>
              <v-btn dark color="primary" @click="closeRecuperaSenha">{{ $t("button.cancel") }}</v-btn>
              <v-btn dark color="primary" @click="enviaRecuperacaoSenha">{{ $t("button.send") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card class="mx-auto" max-width="500" rounded elevation="3">
          <v-card-title>
            <span class="headline" style="color: #4a4a4a">{{ $t("login.title") }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="formValidado">
              <!-- @submit-prevent="login"> -->
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="usuario.username" :label="$t('user.username')"
                    :rules="[(v) => !!v || $t('system.messages.userRequired')]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="usuario.senha" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'" :label="$t('user.password')" @click:append="show1 = !show1"
                    :rules="[(v) => !!v || $t('system.messages.pswdRequired')]"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="end" style="margin: 0;">
                <v-btn text @click="recuperarSenha" x-small>{{ $t("login.resetPassword") }}</v-btn>
              </v-row>
            </v-form>
              <br />
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <vue-recaptcha
                    v-if="shouldRenderRecaptcha"
                    ref="recaptchacomp"
                    :sitekey="sitekey"
                    @verify="captchaVerified"
                    @expired="captchaExpired"
                  ></vue-recaptcha>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-right">
                  <v-btn color="button" class="white--text" @click="login"
                    >Entrar</v-btn
                  >
                </v-col>
              </v-row>
          </v-card-text>

          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" class="white--text" type="submit">Login</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import { ChaveRecaptcha } from "@/constants";
import { VueRecaptcha } from "vue-recaptcha";
import { mapMutations, mapGetters } from "vuex";
import EventBus from "@/utils/eventBus";
import { resolvePostLoginPath, storePermissoesTelas } from "@/utils/postLoginNavigation";

export default {
  components: { VueRecaptcha },
  data: () => ({
    formValidado: true,
    sitekey: "",
    show1: false,
    error: false,
    recaptcha: false,
    usuario: {
      username: null,
      senha: null,
    },
    recuperaSenhaDialog: false,
    email: null,
    formRecuperaSenhaValidado: false,
    alertaEmail: false,
    mensagemAlertaEmail: "",
    loadingRecuperaSenha: false,
  }),
  created() {
    this.sitekey = ChaveRecaptcha || "";
    if (!this.shouldUseRecaptcha) {
      this.recaptcha = true;
    }
  },
  mounted() {
    let self = this;
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("api");
    sessionStorage.removeItem("permissoes");
    sessionStorage.removeItem("home");
    this.$root.$emit("toogleMenu", false);
    window.addEventListener("keyup", function (event) {
      if (event.keyCode === 13) {
        self.login();
      }
    });
  },
  computed: {
    ...mapGetters('config', [
      'allConfig',
    ]),
    shouldUseRecaptcha() {
      const hostname = window.location.hostname
        .replace(/^\[|\]$/g, "")
        .toLowerCase();
      const isLocalhost = hostname === "localhost"
        || hostname.endsWith(".localhost")
        || hostname === "::1"
        || /^127(?:\.\d{1,3}){3}$/.test(hostname);
      return !isLocalhost;
    },
    shouldRenderRecaptcha() {
      return this.shouldUseRecaptcha && Boolean(this.sitekey);
    },
  },
  methods: {
    ...mapMutations('config', [
      'setConfig']),
    ...mapMutations('user', [
      'setUser'
    ]),
    login() {
      const self = this;
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.recaptcha || !this.shouldUseRecaptcha) {
          apiController.request(apiController.endpoints.autenticacao, {
            data: this.usuario,
            silent: true,
            auth: false,
            onSuccess: (response) => {
              if (response.data.auth == false) {
                  EventBus.$emit('show-alert', {
                      mensagem: response.data.mensagem,
                      tipo: 'error'
                  });
              } else {
                window.removeEventListener("keyup", function (event) {
                  if (event.keyCode === 13) {
                    self.login();
                  }
                });
                sessionStorage.setItem("user", JSON.stringify(response.data.login[0]));
                sessionStorage.setItem("api", response.data.token);
                const permissoesAuth = storePermissoesTelas(
                  response.data.login[0].permissoes || []
                );
                this.$root.$emit("setPermissoes", permissoesAuth);
                this.$root.$emit("toogleMenu", true);
                this.$root.$emit("setUserName", response.data.login[0].nome_usuario);
                this.$root.$emit("setPerfilUsuario", response.data.login[0].perfil_usuario);
                this.$root.$emit("setUser", response.data.login[0]);
                if (response.data.login[0].id_perfil_usuario == 3) {
                  this.$root.$emit("toogleMenuCadastros", false);
                  this.$root.$emit("toogleMenuOperacao", false);
                  this.$root.$emit("toogleMenuRelatorios", false);
                } else {
                  if (response.data.login[0].id_perfil_usuario == 4) {
                    this.$root.$emit("toogleMenuCadastros", true);
                    this.$root.$emit("toogleMenuOperacao", true);
                    this.$root.$emit("toogleMenuRelatorios", true);
                  } else {
                    this.$root.$emit("toogleMenuCadastros", false);
                    this.$root.$emit("toogleMenuOperacao", true);
                    this.$root.$emit("toogleMenuRelatorios", true);
                  }
                }
                this.getUserPermissions(response.data.login[0]);
                this.setUser(response.data.login[0]);
                this.$store.dispatch('permissoesAcesso/carregar');
                this.getConfig();
              }
            },
            onError: (e) => {
              console.log(e);
            },
          });
        } else {
          EventBus.$emit('show-alert', {
              mensagem: this.$t('system.messages.recaptchaRequired'),
              tipo: 'error'
          });
          this.recaptcha = false;
        }
      }
    },
    getUserPermissions(user) {
      apiController.request(apiController.endpoints.getPermissoestelas, {
        data: user,
        onSuccess: (response) => {
          const permissoes = storePermissoesTelas(response.data);
          this.$root.$emit("setPermissoes", permissoes);
          this.navigateAfterLogin(user, permissoes);
        },
      });
    },
    navigateAfterLogin(user, permissoes) {
      const targetPath = resolvePostLoginPath(this.$router, this.loginRedirectTarget(user.home_page), user, permissoes);
      if (!targetPath) {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("api");
        sessionStorage.removeItem("permissoes");
        sessionStorage.removeItem("home");
        this.$root.$emit("toogleMenu", false);
        EventBus.$emit('show-alert', {
          mensagem: this.$t('system.messages.noScreenPermission'),
          tipo: 'error',
        });
        return;
      }
      sessionStorage.setItem("home", targetPath);
      const storedUser = { ...user, home_page: targetPath };
      sessionStorage.setItem("user", JSON.stringify(storedUser));
      this.setUser(storedUser);
      this.$nextTick(() => {
        this.$router.push(targetPath).finally(() => {
          this.$root.$emit("checkUpdateNotes");
        });
      });
    },
    loginRedirectTarget(homePage) {
      const redirect = this.$route.query.redirect;
      if (typeof redirect === "string" && redirect.startsWith("/") && redirect !== "/") {
        return redirect;
      }
      const hashRedirect = window.location.hash;
      if (hashRedirect && hashRedirect.startsWith("#/") && hashRedirect !== "#/") {
        return hashRedirect.slice(1);
      }
      return homePage;
    },
    captchaVerified() {
      this.recaptcha = true;
    },
    captchaExpired() {
      this.recaptcha = false;
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.setConfig(response.data[0]);
        },
      });
    },
    recuperarSenha() {
      this.recuperaSenhaDialog = true;
    },
    closeRecuperaSenha() {
      this.recuperaSenhaDialog = false;
      this.$nextTick(() => {
        this.email = null;
        this.$refs.formRecuperaSenha.resetValidation();
        this.mensagemAlertaEmail = "";
        this.alertaEmail = false;
      })
    },
    validaEmail(v) {
      return !!v || this.$t("system.messages.invalidEmail");
    },
    enviaRecuperacaoSenha() {
      this.$refs.formRecuperaSenha.validate();
      if (this.formRecuperaSenhaValidado) {
        this.loadingRecuperaSenha = true;

        apiController.request(apiController.endpoints.recuperasenha, {
          data: {email: this.email},
          onSuccess: (response) => {
            this.loadingRecuperaSenha = false;
            if (response.data.erro) {
              this.mensagemAlertaEmail = response.data.mensagem;
              this.alertaEmail = true;
            } else {
              this.closeRecuperaSenha();
              EventBus.$emit('show-alert', {
                  mensagem: response.data.mensagem,
                  tipo: 'success'
              });
            }
          },
          onError: () => {
            this.loadingRecuperaSenha = false;
          },
        });
      }
    }
  },
};
</script>
